import { EReviewRejectionReason } from '@mahawi/eshop-common/dist/src/types';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ReviewAuthenticityNotice(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <section
      className="review-authenticity"
      aria-labelledby="review-authenticity-title"
    >
      <h2 id="review-authenticity-title">{t('reviews.authenticity.title')}</h2>
      <ul>
        <li>{t('reviews.authenticity.verifiedPurchase')}</li>
        <li>{t('reviews.authenticity.noIncentives')}</li>
        <li>{t('reviews.authenticity.allPublished')}</li>
      </ul>
      <p>{t('reviews.authenticity.rejectionIntro')}</p>
      <ul className="review-authenticity--reasons">
        {Object.values(EReviewRejectionReason).map(
          (reason: EReviewRejectionReason): React.JSX.Element => (
            <li key={reason}>{t(`reviews.rejectionReason.${reason}`)}</li>
          ),
        )}
      </ul>
    </section>
  );
}
